import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { FormControl, Validators } from '@angular/forms';
import * as moment from 'moment';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs';
// Observable class extensions
import 'rxjs/add/observable/of';

// Observable operators
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';
import { CommonService, ServiceWalkInService, SubscribeService } from '../../../services/index';
import { ServiceWalkInModel, EmployeeModel } from '../../../model/index';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { FileHolder,ImageUploadModule,ImageUploadComponent } from 'angular2-image-upload';

@Component({
    selector: 'add-service-walk-in-tab',
    templateUrl: './addServiceWalkIn.component.html'
})
export class AddServiceWalkInComponent implements OnInit {
    subscribeAuth: Subscription;
    private searchTerms = new Subject<string>();

    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    _params: any[] = [];
    serviceDataSubscribe: Subscription;
    @Input() set params(val: any[]) {
        this._params = val;
        if(this.usertype != 'Super_Admin' && this.usertype != 'Admin'){
            this._params['mobile'] = this._params['disp_mobile'];
        }
        this.setPageData();
    };
    @Input() image_name = [];


    statusCusCtrl: FormControl;
    typeCtrl: FormControl;
    haModelCtrl: FormControl;
    serialNoCtrl: FormControl;
    potCusCtrl: FormControl;
    clientCtrl: FormControl;
    statusWalkCusCtrl: FormControl;
    referenceCtrl: FormControl;
    branchCtrl: FormControl;
    storeCtrl: FormControl;
    employeeCtrl: FormControl;
    potCusOptList: any[];
    statusWalkinList: any[];
    statusList: any[];
    typeList: any[];
    clientList: any[];
    prodList: any[] = [];
    store_hvOptList: any[];
    store_hvCtrl: FormControl;
    hvUserCtrl: FormControl;
    page = {
        limit: 20,
        count: 0,
        offset: 0,
        orderBy: 'bill_id',
        orderDir: 'asc'
    };
    salesBillentryDetails = [];
    columns = [];
    branchList: any[] = [];
    storeList: any[] = [];
    hvUserList: any[] = [];
    filteredHvuserlist: Observable<any[]>;
    filteredItems: Observable<any[]>;
    filteredReference: Observable<any[]>;
    filteredSerialNo: Observable<any[]>;
    filteredHa: Observable<any[]>;
    filteredBranch: Observable<any[]>;
    filteredStore: Observable<any[]>;
    filteredEmployee: Observable<any[]>;
    @Input() servicegriddata: ServiceWalkInModel[] = [];
    @Input() serviceInData: ServiceWalkInModel[] = [];
    @ViewChild('clientAutoComp') clientAutoComp;
    @ViewChild('prodAutoComp') prodAutoComp;
    // @ViewChild('singleClientDetails') singleClientDetails;
    @ViewChild('searchComponent') searchComponent;
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    itemList: any[] = [];
    isLoading: boolean = false;
    minDate: any;
    usertype: any;
    actSerialNoList: any[];
    serialNoList: any[];
    bsModalRefs: BsModalRef;
    @ViewChild('serviceimgForm') serviceimgForm: AddServiceWalkInComponent;
    subscribeBranch;

    constructor(
        public store: Store<fromRootStore.State>,
        public toasterService: ToasterService,
        private commonService: CommonService,
        private serviceWalkInService: ServiceWalkInService,
        public subscribeService: SubscribeService,private modalService: BsModalService
    ) {
        this.potCusCtrl = new FormControl();
        this.statusCusCtrl = new FormControl();
        this.typeCtrl = new FormControl();
        this.statusWalkCusCtrl = new FormControl();
        //this.serialNoCtrl = new FormControl();
        this.potCusOptList = ['Yes', 'No'];
        this.statusList = ['Yes', 'No'];
        this.statusWalkinList = ['Service','Mould','New Order','Reservice']; //, 'Mould', 'New Order'
        this.typeList = ['Customer', 'Store'];

        function hasValidStore(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "STORE" && ledgerID != "HV" && ledgerID != "SOA") {
                retVal = { inValidStatus: true };
            }

            return retVal;
        }
        this.store_hvCtrl = new FormControl('', [
            Validators.required,
            hasValidStore.bind(this)
        ]);
        this.store_hvOptList = ['STORE', 'HV', 'SOA'];
        //this.clientCtrl = new FormControl();

        //FOR AUTO COMPLETE VALIDATION --- HA MODEL
        function hasValidHaModel(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidHaModel: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidHaModel: true };
            }
            return retVal;
        }

        function hasValidWalkinStatus(input: FormControl) {
            let walkID = input.value, retVal = null;
            if (walkID != "Service" && walkID != "Mould" && walkID != "New Order" && walkID != "Reservice"
            ) {
                retVal = { inValidStatus: true };
            }

            return retVal;
        }

        this.statusWalkCusCtrl = new FormControl({value: '', disabled: false} , [
            Validators.required,
            hasValidWalkinStatus.bind(this)
        ]);
        
        this.haModelCtrl = new FormControl('', [
            Validators.required,
            hasValidHaModel.bind(this)
        ]);
        this.filteredHa = this.haModelCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterHa(name) : this.prodList.slice());

        this.referenceCtrl = new FormControl();
        this.filteredReference = this.referenceCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterItems(name) : this.itemList.slice());

        this.serialNoCtrl = new FormControl();
        this.filteredSerialNo = this.serialNoCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterSerialNo(name) : this.serialNoList.slice());

        this.branchCtrl = new FormControl();
        this.filteredBranch = this.branchCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBranch(name) : this.branchList.slice());

        this.storeCtrl = new FormControl();
        this.filteredStore = this.storeCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterStore(name) : this.storeList.slice());
        
        this.hvUserCtrl = new FormControl();
        this.filteredHvuserlist = this.hvUserCtrl.valueChanges
        .startWith(null)
        .map(name => name ? this.filterHvUser(name) : this.hvUserList.slice());

        this.employeeCtrl = new FormControl();

        this.filteredEmployee = this.employeeCtrl.valueChanges
            .startWith('')
            .debounceTime(300)
            .distinctUntilChanged()
            .switchMap(term => {
                if (term && typeof term === 'string' && term.length >= 2) {
                    return this.commonService.getEmployeeList(term, 'challan');
                } else {
                    return Observable.of<any[]>([]);
                }
            })
            .catch(error => {
                console.log(error);
                return Observable.of<any[]>([]);
            });
    }

    ngOnInit(): void {
        let that = this;
        that.getHVUserList();
        this.filteredItems = this.searchTerms
            .debounceTime(300)        // wait 300ms after each keystroke before considering the term
            .distinctUntilChanged()   // ignore if next search term is same as previous
            .switchMap(term => term   // switch to new observable each time the term changes
                // return the http search observable
                ? this.commonService.loadClientList(term, 'walkIn')
                // or the observable of empty heroes if there was no search term
                : Observable.of<any[]>([]))
            .catch(error => {
                // TODO: add real error handling
                console.log(error);
                return Observable.of<any[]>([]);
            });

        this.filteredItems.subscribe(($e) => {
            that.clientList = $e;
        });

        this.columns = [
            { name: 'SNo', prop: 'sno', width: 50, minWidth: 50, maxWidth: 50, sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Model', prop: 'prod_name', width: 150, minWidth: 150, maxWidth: 150, sortable: false, cellClass: 'cell-left' },
            { name: 'Serial No', prop: 'serial_no', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Brand', prop: 'brand_name',width:100,minWidth:100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Brand Model', prop: 'brand_model_name',width:140,minWidth:140, maxWidth: 140, sortable: false, cellClass: 'cell-left' },
            { name: 'Family', prop: 'family_name',width:80,minWidth:80, maxWidth: 80, sortable: false, cellClass: 'cell-left' },
            { name: 'Series', prop: 'series_name',width:80,minWidth:80, maxWidth: 80, sortable: false, cellClass: 'cell-left' },
            { name: 'Performance', prop: 'performance_name',width:130,minWidth:130, maxWidth: 130, sortable: false, cellClass: 'cell-left' },
            { name: 'Power', prop: 'power_name',width:100,minWidth:100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Battery', prop: 'battery_name',width:100,minWidth:100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Color', prop: 'color_name', width: 120, minWidth: 120, maxWidth: 120, sortable: false, cellClass: 'cell-left' },
            { name: 'Tele Audiology', prop: 'tele_audiology',width:120,minWidth:120, maxWidth: 120, sortable: false, cellClass: 'cell-left' },
            { name: 'Qty', prop: 'qty', width: 60, minWidth: 60, maxWidth: 60, sortable: false, cellClass: 'cell-right' },
            { name: 'Action', prop: 'sno', width: 60, minWidth: 60, maxWidth: 60, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];

        this.searchComponent.setType(this._params['tabParams']);

        if (this._params['mode'] == 'Add') {
            this.minDate = new Date(new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate());

            this.serviceInData['date'] = new Date();
            
            if(this._params['from_page'] == 'company_service') {
                this.typeCtrl.disable();
                that.serviceInData['bill_id'] = this._params['bill_id'];
                that.serviceInData['client_id'] = this._params['client_id'];
                that.serviceInData['client_no'] = this._params['client_no'];
                that.serviceInData['client_name'] = this._params['client_name'];
                that.serviceInData['mobile'] = this._params['mobile'];
                that.servicegriddata['bill_det_id'] = this._params['bill_id'];
                that.serviceInData['warranty'] = 'Yes';
                that.serviceInData['walk_in_type'] = this._params['walk_in_type'];
                // that.serviceInData['description'] = [];
                that.salesBillentryDetails = [];
                that.serviceInData['sale_bill_id'] = this._params['bill_id'];
                // that.serviceInData['mode'] = 'Add';
                that.getservicegriddataails(that.serviceInData);
            } else {
                this.serviceInData['walk_in_type'] = 'Service';
                if(this._params['page_from'] === 'HV Appointment' || this._params['page_from'] === 'SOA Appointment' ||  this._params['page_from'] === 'SOA Entry' ||  this._params['page_from'] === 'HV Entry') {
                    that.serviceInData['client_id'] = this._params['client_id'];
                    this.typeCtrl.disable();
                    that.serviceInData['bill_id'] = this._params['bill_id'];
                    that.serviceInData['client_no'] = this._params['client_no'];
                    that.serviceInData['client_name'] = this._params['client_name'];
                    that.serviceInData['mobile'] = this._params['mobile'];
                    that.servicegriddata['bill_det_id'] = this._params['bill_id'];
                    that.serviceInData['warranty'] = 'Yes';
                    that.serviceInData['walk_in_type'] = this._params['walk_in_type'];
                    that.serviceInData['sale_bill_id'] = this._params['bill_id'];
                    that.getservicegriddataails(that.serviceInData);
                }
                this.searchComponent.clientSearchEmit.subscribe(($e) => {
                    that.serviceInData['bill_id'] = $e['bill_id'];
                    that.serviceInData['sale_no'] = $e['sale_no'];
                    that.serviceInData['sale_date'] = $e['sale_date'];
                    that.serviceInData['disp_sale_date'] = $e['disp_sale_date'];
                    that.serviceInData['client_id'] = $e['client_id'];
                    that.serviceInData['client_no'] = $e['client_no'];
                    that.serviceInData['client_name'] = $e['client_name'];
                    that.serviceInData['mobile'] = $e['mobile'];
                    that.serviceInData['item'] = $e['item'];
                    that.serviceInData['quantity'] = $e['quantity'];
                    that.serviceInData['reference'] = $e['reference'];
                    that.serviceInData['reference_by'] = $e['reference_by'];
                    //that.prodList = $e['prodRes'];
                    that.serviceInData['warranty'] = [];
                    that.serviceInData['description'] = [];
                    // that.serviceInData['walk_in_type'] = [];
                    that.serviceInData['advance'] = [];
                    that.servicegriddata = [];
                    that.salesBillentryDetails = [];
                    //TO LOAD HA MODEL DETAILS
                    that.serviceInData['sale_bill_id'] = $e['bill_id'];
                    that.serviceInData['mode'] = 'Add';
                    that.getservicegriddataails(that.serviceInData);
                });
            }            

            this.loadAutoNumber();
        }
        // if (this._params['mode'] == 'Add') {
        //     this.loadAutoNumber();
        // }

        this.serviceInData['random_no'] = this.getRandomInt(1, 500);
        this.serviceInData['type'] = "Customer";

        this.subscribeAuth = this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
            if (auth['islogin'] && (auth['usertype'] == 'User' || auth['usertype']=='Super_Admin')) {
                that.serviceInData['branch_short_name'] = auth['branch_short_name'];
                that.serviceInData['branch_id'] = auth['branch_id'];
            }
            this.usertype = auth['usertype'];
        });

        // TO SET SERVICE CLIENT DATA AFTER SAVING
        this.serviceDataSubscribe = this.subscribeService.publishSetClient().subscribe(res => {
            this.saveResponse(res);
        });

        this.subscribeBranch = this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                return;
            }
            this.branchList = _.filter(res.data, function (obj) { return (obj['is_crm_branch'] == 'Yes' &&  obj['chk_name'] !='' && obj['store_branch'] == 'Yes')});
            this.storeList = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' && obj['store_branch'] == 'Yes' });
        });

    }

    ngOnDestroy() {
        // prevent memory leak when component destroyed
        if (!_.isEmpty(this.subscribeAuth)) {
            this.subscribeAuth.unsubscribe();
        }

        // UNSUBSCRIBE SERVICE CLIENT DATA
        this.serviceDataSubscribe.unsubscribe();
    }

    loadAutoNumber(): void {
        let that = this,
            data = {
                account_type: 'serviceTrack',
                date: moment(this.serviceInData['date']).format('YYYY-MM-DD')
            };
        this.commonService
            .getAutoNumber(data)
            .then(function (res: any) {
                if (res['success']) {
                    that.serviceInData['auto_no'] = res['auto_no'];
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Oops, Something Went Wrong'
                    };
                    that.toasterService.pop(toast);
                }
            });
    }

    setPageData(): void {

        if (this._params != undefined) {
            let mode = this._params['mode'];
            if (mode == 'Edit') {
                let data = this._params;
                this.serviceInData = this._params;
                this.serviceInData['auto_no'] = this._params['bill_no'];
                this.serviceInData['date'] = new Date(this._params['addedon']);//new Date();
                this.serviceInData['advance'] = this._params['service_advance_amt'];
                if (this.serviceInData['description']) {
                    this.serviceInData['description'] = this.serviceInData['description'].split('<br>')[0];
                }
                this.serviceInData['branch_short_name'] = this._params['chk_name'];
                this.serviceInData['client_branch_id'] = this._params['branch_id'];
                this.serviceInData['company_id'] = this._params['to_branch'];
                this.hvUserCtrl.setValue(this._params['hv_userid']);

                if (this._params['employee_id']) {
                    const empName = this._params['employee_name'] || this._params['emp_name'] || '';
                    const empObj = { empid: this._params['employee_id'], empname: empName };
                    this.employeeCtrl.setValue(empObj, { emitEvent: false });
                    this.serviceInData['employee_id'] = empObj;
                }

                this.getservicegriddataails(data);
                // this.singleClientDetails.loadClient(this.serviceInData['client_id']);
            }
        }
    }

    getHVUserList() {
        let that = this;
        let data = {
            fol_id: 1
        };
        that.commonService
            .getHVUserList(data)
            .then(function (res: any) {
                if (res && res.data && res.data.length) {
                    that.hvUserList = res.data;
                    if (that._params['mode'] != 'Add') {
                        that.hvUserCtrl.setValue(that._params['hv_userid']);
                    }
                }
            });
    }

    // onChangeStore(){
       
    //     if(this.serviceInData['store_type']=='HV' || this.serviceInData['store_type']=='SOA'){
    //         this.getHVUserList();
    //     } else {
    //         this.storeList = _.filter(this.storeList, function (obj) { return obj['is_crm_branch'] == 'Yes' && obj['store_branch'] == 'Yes'});
    //     }
    //     console.log('this.storeList',this.hvUserList);
    // }

    getservicegriddataails(data: any): void {
        let that = this,
            params = {
                sale_bill_id: data.sale_bill_id,
                ser_id: data.ser_id,
                mode: data.mode,
                from_page: that._params['from_page'],
                client_id: data.client_id
            };
        this.getClientMobileNo(data.client_id);
        this.serviceWalkInService
            .getServiceModelDetails(params)
            .then(function (res: any) {
                that.prodList = res.prodRes;
                // if(that._params['from_page'] == 'company_service') {
                //     that.salesBillentryDetails = res.prodRes;
                //     that.page.count = res.prodRes.length;
                // } else {
                    that.page.count = res.totCnt;
                    that.salesBillentryDetails = res.data;
                    that.haModelCtrl.setValue(that.prodList['name']);
                // }
            });
    }

    getClientMobileNo(clientID): void {
            let that = this,
                params = {
                    client_id: clientID
                };
            this.commonService
                .getClientMobileNo(params)
                .then(function (res: any) {
                    console.log("resp",res.data);
                });
    }

    loadBranchHaModalStockList() {
        let that = this,
            data = {
                from_page: 'Service Walk-in'
            };
        this.commonService
            .getHaModelStock(data)
            .then(function (res: any) {
                // that.haList = res['haStockModel'];
                // that.actSerialNoList = res['haModelStockSerial'];
                // that.halistCtrl.setValue(that.salesBillgriddata['model_id']);

                
                // that.page.count = res.totCnt;
                // that.salesBillentryDetails = res.data;
                that.prodList = res.haStockModel;
                that.actSerialNoList = res.haModelStockSerial;
                that.serviceInData['client_id'] = res.storeDet.client_id;
                that.serviceInData['client_no'] = res.storeDet.client_no;
                that.serviceInData['client_name'] = res.storeDet.client_name;
                that.serviceInData['mobile'] = res.storeDet.mobile;
                that.serviceInData['mobile'] = res.storeDet.mobile;
                that.serviceInData['sale_date'] = new Date();
                that.haModelCtrl.setValue(that.prodList['name']);
                
            });
    }

    getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    searchClient(query: string) {
        this.searchTerms.next(query);
    }

    onEnterKeyPressed(nextEl: string): void {
        if (_.isEmpty(document.getElementById(this.serviceInData['random_no'] + '_' + nextEl))) {
            nextEl = 'followup_status';
        }
        $('#' + this.serviceInData['random_no'] + '_' + nextEl).focus();
    }

    displayFn(client_id: any) {
        if (this.clientList != undefined) {
            if (client_id && this.clientList.length > 0) {
                let fitem = _.find(this.clientList, { 'client_id': client_id });
                this.serviceInData['sale_no'] = fitem.sale_no;
                this.serviceInData['sale_date'] = fitem.sale_date;
                this.serviceInData['item'] = fitem.item;
                this.serviceInData['quantity'] = fitem.quantity;
                this.serviceInData['client_no'] = fitem.client_no;
                this.serviceInData['client_name'] = fitem.client_name;
                this.serviceInData['mobile'] = fitem.mobile; //ANOTHER FIELD
                this.serviceInData['reference_name'] = fitem.reference_name;
                //  this.singleClientDetails.loadClient(fitem);//TO LOAD CLIENT OBJECT
                return fitem['client_no'];
            }
        }
        return '';
    }
    //  for loading the product and qunatity on change function
    displayProd(bill_det_id: any) {
        this.serialNoList = [];
        if (this.prodList != undefined) {
            if (bill_det_id && this.prodList.length > 0) {
                let fitem = _.find(this.prodList, { 'bill_det_id': bill_det_id });
                // this.serialNoList.push(fitem);
                let actSerialNoList = this.actSerialNoList;
                this.serialNoList = _.filter(actSerialNoList, { 'model_id': bill_det_id });

                this.onChangeProd(fitem);
                return fitem['name'];
            }
        }
        return '';
    }

    filterHa(name: string) {
        name = _.escapeRegExp(name);
        return this.prodList.filter(ha => (new RegExp(name, 'gi').test(ha.name)));
    }

    onChangePrefix(opt: any){
        const that = this;
        const branchId = opt.branch_id;
        const fbranchPrefix = _.find(this.branchList, { 'branch_id': branchId });
        that.serviceInData['branch_short_name'] = fbranchPrefix['chk_name'];
        that.serviceInData['branch_id'] = fbranchPrefix['branch_id'];
    }

    onChangeProd(ha: any) {
        const that = this;
        const bill_det_id = ha.bill_det_id;
        const fitem = _.find(this.prodList, { 'bill_det_id': bill_det_id });
        //TO LOAD MACHINE OBJECT

        that.servicegriddata['prod_name'] = fitem['name'];
        that.servicegriddata['model_id'] = fitem['model_id'];
        that.servicegriddata['quantity'] = fitem['quantity'] ? fitem['quantity'] : fitem['avail_qty'];
        that.servicegriddata['serial_no'] = fitem['serial_no'];
        this.servicegriddata['brand_name'] = fitem['brand_name'];
        this.servicegriddata['brand_model_name'] = fitem['brand_model_name'];
        this.servicegriddata['family_name'] = fitem['family_name'];
        this.servicegriddata['series_name'] = fitem['series_name'];
        this.servicegriddata['performance_name'] = fitem['performance_name'];
        this.servicegriddata['power_name'] = fitem['power_name'];
        this.servicegriddata['battery_name'] = fitem['battery_name'];
        this.servicegriddata['color_name'] = fitem['color_name'];
        this.servicegriddata['tele_audiology'] = fitem['tele_audiology'];
        this.servicegriddata['brand_id'] = fitem['brand_id'];
        this.servicegriddata['brand_model_id'] = fitem['brand_model_id'];
        this.servicegriddata['family_id'] = fitem['family_id'];
        this.servicegriddata['series_id'] = fitem['series_id'];
        this.servicegriddata['performance_id'] = fitem['performance_id'];
        this.servicegriddata['power_id'] = fitem['power_id'];
        this.servicegriddata['battery_id'] = fitem['battery_id'];
        this.servicegriddata['color_id'] = fitem['color_id'];

    }

    onChangeType(type: string) {
        // this.serviceInData = [];
        this.salesBillentryDetails = [];
        this.page.count = 0;
        if(this.serviceInData['type'] == 'Store') {
            this.loadBranchHaModalStockList();
        } 
    }

    // end
    resetWalkInData() {
        if (this._params['mode'] == 'Add') {
            this.serviceInData = [];
            this.serviceInData['date'] = new Date();
        }
    }
    /*  loadFollowUpStatus(): void {
          let that = this;

          that.commonService
              .getFollowUpStatusList({})
              .then(function(res: any) {
                  that.statusList = res.data;
              });
      }*/
    displayStatusFn(fol_id: any) {
        if (this.statusList != undefined) {
            if (fol_id && this.statusList.length > 0) {
                let folObj = _.find(this.statusList, { 'fol_id': fol_id });
                return folObj['name'];
            }
        }
        return '';
    }


    filterItems(name: string) {
        name = _.escapeRegExp(name);
        return this.itemList.filter(item => (new RegExp(name, 'gi').test(item.client_code) || new RegExp(name, 'gi').test(item.name)));
    }

    displayRef(item_id: number) {
        if (item_id && this.itemList.length > 0) {
            let fitem = _.find(this.itemList, { 'ref_id': item_id });
            return fitem['name'];
        }
        return '';
    }

    filterSerialNo(name: string) {
        name = _.escapeRegExp(name);
        return this.serialNoList.filter(ha => (new RegExp(name, 'gi').test(ha.serial_no)));
    }

    filterBranch(name: string) {
        name = _.escapeRegExp(name);
        return this.branchList.filter(item => (new RegExp(name, 'gi').test(item.branch_name)));
    }

    displayFun(branchID: any) {
        if (this.branchList != undefined) {
            if (branchID && this.branchList.length > 0) {
                let fitem = _.find(this.branchList, { 'branch_id': branchID });
                return fitem['branch_name'];
            }
        }
        return '';
    }

    filterStore(name: string) {
        name = _.escapeRegExp(name);
        return this.storeList.filter(item => (new RegExp(name, 'gi').test(item.branch_name)));
    }

    displayStoreFn(branchID: any) {
        if (this.storeList != undefined) {
            if (branchID && this.storeList.length > 0) {
                let fitem = _.find(this.storeList, { 'branch_id': branchID });
                return fitem['branch_name'];
            }
        }
        return '';
    }

    // HV User display
    filterHvUser(name: string) {
        name = _.escapeRegExp(name);
        return this.hvUserList.filter(ha => (new RegExp(name, 'gi').test(ha.fullname)));
    }

    assignFn(empid: any) {
        if (this.hvUserList != undefined) {
            if (empid && this.hvUserList.length > 0) {
                if (typeof empid == 'string') {
                    empid = parseInt(empid);
                }
                let fitem = _.find(this.hvUserList, { 'userid': empid });
                return fitem && fitem['fullname'] ? fitem['fullname'] : '';
            }
        }
        return '';
    }

    displayEmployee(employee: any) {
        if (employee && typeof employee === 'object') {
            return employee.empname || employee.fullname;
        }
        return employee;
    }

    extractEmployeeId(employee: any): any {
        if (employee && typeof employee === 'object') {
            return employee.empid || employee.userid || '';
        }
        return employee;
    }

    displaySerialNo(serial_no: number) {
        if (serial_no && this.serialNoList.length > 0) {
            let fhalist = _.find(this.serialNoList, { 'serial_no': serial_no }),
                rate = 0,
                mrp = fhalist.model_mrp;
            // if (parseFloat(fhalist.mrp) < parseFloat(fhalist.model_mrp)) {
            //     mrp = fhalist.mrp;
            // }
            // this.salesBillgriddata['mrp'] = mrp;
            // this.salesBillgriddata['challan_out_id'] = fhalist.challan_out_id;
            // //if(this._params['tabParams'] !== 'Advance') {
            //     this.salesBillgriddata['serial_no'] = fhalist.serial_no;
            // //}
            // this.salesBillgriddata['tax_per'] = fhalist.tax_per;
            // this.salesBillgriddata['quantity'] = 1;

            // /* if (parseFloat(fhalist.tax_per) > 0) {
            //      rate = parseFloat(mrp)*100/(100-  parseFloat(fhalist.tax_per));
            //  } else {
            //      rate = parseFloat(mrp);
            //  }*/
            // if (!_.isEmpty(_.toString(fhalist.tax_per))) {
            //     rate = ((mrp) * (parseFloat(fhalist.tax_per)) / (100)) + (mrp);
            // }
            // rate = Math.round(rate);
            // //rate = Math.round(rate);
            // this.salesBillgriddata['rate'] = rate;
            // this.calAmount();

            return fhalist['serial_no'];
        }
        return '';
    }

    onDeleteSalesbillentry(row: any): void {
        let that = this,
            mode = this._params['mode'];


        if (mode == 'Add') {
            this.salesBillentryDetails.splice(this.salesBillentryDetails.indexOf(row), 1);

        } else {
            let params = {
                name: row['prod_name'],
                model_id: row['model_id'],
                ser_id: row.ser_id,
            };

            //  this.salesBillgriddata = [];

            this.serviceWalkInService
                .deleteGridList(params)
                .then(function (res: any) {
                    that.isLoading = false;
                    if (res.success) {
                        that.salesBillentryDetails.splice(that.salesBillentryDetails.indexOf(row), 1);
                        swal('SUCCESS', res.message, 'success');

                        // that.getServiceWalkInList()

                    } else {

                        swal('ERROR', res.message, 'error');
                    }
                });
        }
    }
    addServiceInentry(): void {

        let that = this,
            toast = {
                type: 'warning',
                title: 'WARNING'
            },
            mode = this._params['mode'],
            name = this.servicegriddata['prod_name'],
            modelID = this.servicegriddata['model_id'],
            serialNo = this.servicegriddata['serial_no'],
            availQty = this.servicegriddata['quantity'],
            modelName = this.servicegriddata['prod_name'],
            enteredQty = this.servicegriddata['qty'];



        if (!_.isEmpty(_.toString(modelID))) {

            let preTestID = _.find(this.salesBillentryDetails, { 'model_id': modelID });
            let serial_no = _.find(this.salesBillentryDetails, { 'serial_no': serialNo });

            if (preTestID && serial_no) {
                toast['body'] = 'Model : ' + modelName + ' Already Exists';
                this.toasterService.pop(toast);
                return;
            }

            else if (_.isEmpty(_.toString(enteredQty))) { // 11 > 10
                toast['body'] = 'Please Enter  Quantity';
                this.toasterService.pop(toast);
                return;
            }

            else if (_.toNumber(enteredQty) > _.toNumber(availQty)) { // 11 > 10
                toast['body'] = 'Please Enter Valid Quantity. It should less than or equal to  Sold Quantity';
                this.toasterService.pop(toast);
                return;
            }

            else if (_.toNumber(enteredQty) == 0) { // 11 > 10
                toast['body'] = 'Please Enter Valid Quantity. 0 is not Valid';
                this.toasterService.pop(toast);
                return;
            }

            if (mode == 'Add') {

                let testDet = Object.assign({}, this.servicegriddata);
                this.salesBillentryDetails.push(testDet);
                this.servicegriddata = [];
                this.servicegriddata['amount'] = 0;
                that.page.count = this.salesBillentryDetails.length;

                //this.serialNoList = [];
            } else if (mode == 'Edit') {
                let params = {
                    ser_id: this.serviceInData['ser_id'],
                    model_id: this.servicegriddata['model_id'],
                    name: this.servicegriddata['prod_name'],
                    quantity: this.servicegriddata['quantity'],
                    qty: this.servicegriddata['qty'],
                    serial_no: this.servicegriddata['serial_no']
                },
                    testDet = Object.assign({}, this.servicegriddata);

                this.serviceWalkInService
                    .addServiceWalkIn(params)
                    .then(function (res: any) {
                        that.isLoading = false;

                        if (res.success) {
                            swal('SUCCESS', res.message, 'success');

                            that.salesBillentryDetails.push(testDet);
                            that.servicegriddata = [];

                            that.page.count = that.salesBillentryDetails.length;


                            // that.getServiceWalkInList();
                        } else {
                            swal('ERROR', res.message, 'error');
                        }
                    })
            }
            return;
        }

    }

    saveResponse(data) {
        const gridData = JSON.parse(data.serviceClientDetails);
        this.serviceInData['bill_id'] = data.bill_id;
        this.serviceInData['client_id'] = data.client_id;
        this.serviceInData['client_no'] = data.client_no;
        this.serviceInData['client_name'] = data.client_name;
        this.serviceInData['mobile'] = data.mobile;
        this.serviceInData['description'] = data.description;
        this.page.count = gridData.length;
        if (gridData) {
            gridData.map(res => { 
                res['prod_name'] = res.model_name; 
                res['qty'] = res.act_qty;
                this.salesBillentryDetails.push(res);
            });
        }
    }

    onSaveWalkIn() {
        let that = this,
            mode = this._params['mode'],
            testingDet = this.salesBillentryDetails.length,
            toast = {
                type: 'warning',
                title: 'WARNING'
            };

        if (testingDet == 0) {
            swal('WARNING', 'No Data Found, <br> Please Add Service Details');
            return;
        } else if (_.isEmpty(this.serviceInData['warranty'])) {
            toast['body'] = 'Please choose Warranty';
            this.toasterService.pop(toast);
            return;
        } else if (_.isEmpty(this.serviceInData['description'])) {
            toast['body'] = 'Please Type Description';
            this.toasterService.pop(toast);
            return;
        } else if (_.isEmpty(this.serviceInData['walk_in_type'])) {
            toast['body'] = 'Please Type Service Walk In Type';
            this.toasterService.pop(toast);
            return;
        
        } else if (_.isEmpty(_.toString(this.serviceInData['mobile']))) {
            toast['body'] = 'Please Enter Mobile No';
            this.toasterService.pop(toast);
            return;
        };
        
        if(this.serviceInData['advance'] == ''){
            this.serviceInData['advance']=0   
        }
      
        let testingDate = moment(this.serviceInData['date']).format('YYYY-MM-DD'),
            data = {
                sale_bill_id: this.serviceInData['bill_id'],
                ser_id: this.serviceInData['ser_id'],
                sale_no: this.serviceInData['sale_no'],
                sale_date: this.serviceInData['sale_date'],
                auto_no: this.serviceInData['auto_no'],
                srf_no: this.serviceInData['srf_no'],
                srf_prefix: this.serviceInData['branch_short_name'],
                mobile: this.serviceInData['mobile'],
                warranty: this.serviceInData['warranty'],
                date: testingDate,
                client_id: this.serviceInData['client_id'],
                salesBillentryDetails: JSON.stringify(this.salesBillentryDetails),
                description: this.serviceInData['description'],
                walk_in_type: this.serviceInData['walk_in_type'],
                advance: this.serviceInData['advance'],
                mode: this._params['mode'],
                tabParams: this._params['tabParams'],
                img_data:this.filesarray,
                img_count:this.filesarray.length,
                branchId: this.serviceInData['branch_id'],
                store_type: this.serviceInData['store_type'],
                companyid: this.serviceInData['store_type'] == 'STORE' ? this.serviceInData['company_id'] : 0,
                hv_userid: this.serviceInData['store_type'] != 'STORE' ? this.serviceInData['hv_userid'] : 0,
                uploaded_image: this.serviceInData['uploaded_image'] || '',
                employee_id: this.extractEmployeeId(this.serviceInData['employee_id'])
            };
            //console.log("walkin",data.walk_in_type);
        this.isLoading = true;

        if (this._params['page_from'] && (this._params['page_from'] === 'HV Appointment' || this._params['page_from'] === 'SOA Appointment')) {
            data['ha_id'] = this._params['ha_id'];
            data['page_from'] = this._params['page_from'];
            data['followup_id'] = this._params['followup_status'];
        }

        if (this._params['page_from'] && (this._params['page_from'] === 'HV Entry' || this._params['page_from'] === 'SOA Entry')) {
            data['followup_id'] = this._params['followup_status'];
            data['walkin_id'] = this._params['walkin_id'];
            data['page_from'] = this._params['page_from'];
        }

        this.serviceWalkInService
            .addSaveServiceWalkIn(data)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    that.serviceInData = [];
                    that.salesBillentryDetails = [];
                    swal('SUCCESS', res.message, 'success');
                    that.subscribeService.subScribeDeleteActiveTab();
                    that.subscribeService.subReloadServiceGrid();
                    if (that._params['page_from'] == 'HV Appointment' || that._params['page_from'] == 'SOA Appointment') {
                        that.subscribeService.subReloadAppointmentGrid();
                    }
                    if (that._params['page_from'] == 'HV Entry' || that._params['page_from'] == 'SOA Entry') {
                        that.subscribeService.subReloadClientWalkInGrid();
                    }
                } else {
                    swal('ERROR', res.message, 'error');
                }
            })
            .catch(function (error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
                //console.log(error);
            });

    }

    //   START CR-20

    filesarray: any[] = [];
    filesnamearray: any[] = [];
    openModal(template: TemplateRef<any>) {
        this.filesarray=[];
        this.filesnamearray=[];
        this.bsModalRefs = this.modalService.show(template, {
            keyboard: false,
            ignoreBackdropClick: true
        });     
      }
    
      closemodal(){
        this.filesarray=[];
        this.filesnamearray=[];
        this.bsModalRefs.hide();
      }
      saveandclosemodal(event){
      this.bsModalRefs.hide();
    }

      onPhotoUploadFinished(res) {
        let serRes = JSON.parse(res.serverResponse.response._body);
        let serRes1 = res.file;
        if (serRes.success) {
            this.filesarray.push({"filename":serRes['filename'],"orginal_filename":res.file.name});
        }
    }
    
    
      onPhotoRemoved(file: FileHolder) {
        const index = this.filesarray.findIndex(item => item.orginal_filename === file.file.name);
        this.filesarray.splice(index, 1);
      }

    //   END CR-20

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/serviceWalkIn/addServiceWalkIn.component.ts